<template>
  <!-- popup (s) -->
  <div class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0"></span>
    <div class="popup">
      <div class="popContain">
        <div class="popCont" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">이용중인 렌탈 상품</h1>
          </div>
          <div class="popBody" style="height: 300px;">
            <div class="popInner">
              <section>
                <ul class="prdList line">
                  <li v-for="(value, key) in rentalList" :key="key">
                    <div class="block">
                      <div class="prdItem xs">
                        <div class="imgArea">
                          <span class="img">
                            <img
                              :src="value.orderInfo.thumbnail ? value.orderInfo.thumbnail : '/img/error_image.jpg'"
                              alt=""
                              onerror="this.src='/img/error_image.jpg';"
                            />
                          </span>
                        </div>
                        <div class="infoArea">
                          <div class="tit row2">
                            <span>{{ value.orderInfo.productName }}</span>
                          </div>
                          <div class="txtItem">
                            <span>{{ value.orderInfo.model }}</span>
                          </div>
                        </div>

                        <div class="btnGroup">
                          <button type="button" class="btn_s s" @click="$emit('select', value)">선택</button>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front';
import $ from 'jquery';
export default {
  name: 'FriendRecommendPop',
  props: ['rentalList'],
  data() {
    return {
      msg: '',
    };
  },
  created() {},
  mounted() {
    $('body').addClass('popOn');
    //customjs.init();
    customjs.listInit();
  },
  beforeDestroy() {
    $('body').removeClass('popOn');
  },
};
</script>
